import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import Modal from '../common/Modal';
import Image from '../common/Image';
import FlagIcon from '../../assets/FlagIcon';
import ZeroState from '../common/ZeroState';
import FileSeachIcon from '../../assets/FileSearchIcon';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  popupCloseBtn: {
    cursor: 'pointer',
  },
  content: {
    width: '98%',
    height: '67vh',
    overflowY: 'auto',
    background: '#f2f2f6',
    padding: '0px 10px 10px',
  },
  activity: {
    marginTop: '20px',
  },

  story: {
    marginTop: '15px',
  },
  item: {
    width: '95%',
    height: '100px',
    borderRadius: '6px',
    background: '#fff',
    marginTop: '6px',
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
  },
  img: {
    width: '17%',
    height: '90px',
  },
  cap: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#EBE9FE',
    // overflow: 'hidden',
  },
  info: {
    width: '83%',
    height: '90px',
    paddingLeft: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
}));

export const LearningHistory = ({ empHash, setEmpHash, learningHistory }) => {
  const classes = useStyles();

  const getDates = () => {
    const formattedCurrentDate = moment().format('DD/MM/YYYY');
    const formattedOneMonthAgoDate = moment().subtract(1, 'months').format('DD/MM/YYYY');

    return [formattedCurrentDate, formattedOneMonthAgoDate];
  };

  return (
    <Modal isOpen={empHash} height="72vh" width="500px">
      <Grid className={classes.container}>
        <Grid className={classes.heading}>
          <Typography>Learning History</Typography>
          <Grid item xs={1}>
            <CloseIcon className={classes.popupCloseBtn} onClick={() => setEmpHash(null)} />
          </Grid>
        </Grid>
        {learningHistory && learningHistory.length > 0 ? (
          <Grid className={classes.content}>
            {learningHistory.map((weekData, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index}>
                {weekData.days?.map((data) => (
                  <Grid className={classes.activity}>
                    <Typography style={{ fontSize: '16px', fontWeight: '600' }}>
                      {moment(data.date).format('D MMMM, dddd')}
                    </Typography>
                    {data.stories.length > 0 && (
                      <Grid className={classes.story}>
                        <Typography>Story</Typography>
                        {data.stories.map((d) => (
                          <Grid className={classes.item} key={d.id}>
                            <Grid className={classes.img}>
                              <Image
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                src={d.thumbnail}
                              />
                            </Grid>
                            <Grid className={classes.info}>
                              <Typography style={{ fontSize: '12px', color: '#667085' }}>{d.type}</Typography>
                              <Typography>{d.title}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    )}

                    {data.guides.length > 0 && (
                      <Grid className={classes.story}>
                        <Typography>Guide</Typography>
                        {data.guides.map((g) => (
                          <Grid className={classes.item}>
                            <Grid className={classes.img}>
                              <Image
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                src={g.thumbnail}
                              />
                            </Grid>
                            <Grid className={classes.info}>
                              <Typography style={{ fontSize: '12px', color: '#667085' }}>{g.journeyTitle}</Typography>
                              <Typography>{g.title}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    )}

                    {data.capstones.length > 0 && (
                      <Grid className={classes.story}>
                        <Typography>Capstones</Typography>
                        {data.capstones.map((c) => (
                          <Grid className={classes.item}>
                            <Grid className={classes.cap}>
                              <FlagIcon style={{ width: '50%', height: '50%' }} />
                            </Grid>
                            <Grid className={classes.info}>
                              <Typography style={{ fontSize: '12px', color: '#667085' }}>{c.journey?.title}</Typography>
                              <Typography>{c.title}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    )}

                    {data.checkins.length > 0 && (
                      <Grid className={classes.story}>
                        <Typography>Check-in</Typography>
                        {data.checkins.map((c) => (
                          <Grid className={classes.item}>
                            <Grid className={classes.cap}>
                              <FlagIcon style={{ width: '50%', height: '50%' }} />
                            </Grid>
                            <Grid className={classes.info}>
                              <Typography style={{ fontSize: '12px', color: '#667085' }}>{c.journey?.title}</Typography>
                              <Typography>{c.title}</Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </Grid>
                ))}
              </div>
            ))}
          </Grid>
        ) : (
          <Grid className={classes.content}>
            <ZeroState
              Icon={FileSeachIcon}
              text={`No learning history available for time period ${getDates()[0]} - ${getDates()[1]} `}
              style={{ paddingBottom: '100px', paddingTop: '30px' }}
              cardWidth="75%"
            />
          </Grid>
        )}
      </Grid>
    </Modal>
  );
};
